import React, { useState } from 'react';
import useFetchData from '../hooks/vendor/fetchorderdetail.js';
import useDeleteOrder from '../hooks/vendor/useDeleteOrder'; 
import { FaRupeeSign, FaWhatsapp } from "react-icons/fa";
import { useAuth } from '../hooks/AuthContext';
import { FaTrash } from 'react-icons/fa';
 

function OrderDetail({ orderid }) {
  const { setLoading } = useAuth();
  const { data, setData } = useFetchData({ orderid, setLoading });
  const { deleteOrder, loading: deleting } = useDeleteOrder();  

  const [showModal, setShowModal] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState(null);

  const handleDeleteOrder = (orderId) => {
    setOrderToDelete(orderId);
    setShowModal(true);
  };

  const confirmDelete = () => {
    if (orderToDelete) {
      deleteOrder(orderToDelete, () => window.history.back());
      setShowModal(false);
    }
  };



  const cancelDelete = () => {
    setShowModal(false);
  };

  if (!data.length) return null;

  return (
    <div className='previousorder-bx'>
      <div className="order-detail-expanded">
        {data.map(order => (
          <div key={order.order_id} className="order-card">

            <div className="products-list d-flex mb-2 justify-content-between pdlist1">
              <b>ID: {order.order_id}</b>
              <b>Date: {order.added_date}</b>
             
              <b>Mob: {order.usermob}</b>
              <b>Name: {order.name}</b>
                  <button className="delete saw ms-2" onClick={() => handleDeleteOrder(order.order_id)}>
               x
              </button>
           
            </div>
  <div className="products-list d-flex mb-2 justify-content-between pdlist2">
              <b>ID: {order.order_id}</b>
              <b>Date: {order.added_date}</b>
                 <button className="delete saw ms-2" onClick={() => handleDeleteOrder(order.order_id)}>
               x
              </button>
              <b>Mob: {order.usermob}</b>
              <b>Name: {order.name}</b>
           
            </div>


            {order.image && (
              <a
                href={`https://bulkify.in/photo/category/${order.image}`}
                download={order.image}
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={`https://bulkify.in/photo/category/${order.image}`}
                  alt={order.image}
                  className="product-image"
                />
              </a>
            )}

            <div className="products-list">
              {order.basket?.map((item, index) => {
                const imageUrl = `https://bulkify.in/photo/product/${item.imgpath1}`;
                const message = encodeURIComponent(`${imageUrl}`);
                const whatsappUrl = `https://wa.me/+91${order.usermob}?text=${message}`;

                return (
                  <div className="product-item d-flex justify-content-between" key={index}>
                    <img
                      src={imageUrl}
                      alt={item.product_name}
                      className="product-image"
                    />
                    <div className="product-info">
                      <p className="product-name">{item.product_name}</p>
                      {item.price && (
                        <p className="product-price">
                          <b><FaRupeeSign />{item.total_final_price}</b>
                          {item.discount > 0 && (
                            <>
                              &nbsp; ({item.discount}% off) &nbsp;
                              <span style={{ textDecoration: "line-through" }}>
                                <FaRupeeSign />{item.price}
                              </span>
                            </>
                          )}
                        </p>
                      )}
                      <p className="product-quantity">Quantity: {item.quantity}</p>
                    </div>

                    <a 
                      href={whatsappUrl}
                      className="whatsappsend ms-2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaWhatsapp />
                    </a>

                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

   
      {showModal && (
        <div  className='modalStyle' >
          <div className='modalContentStyle'>
            <p>Are you sure you want to delete this order?</p>
            <button className='rdbtndl' onClick={confirmDelete} disabled={deleting}>Yes, Delete</button>
            <button onClick={cancelDelete}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}


// const modalStyle = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   backgroundColor: "rgba(0, 0, 0, 0.5)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modalContentStyle = {
//   backgroundColor: "white",
//   padding: "20px",
//   borderRadius: "8px",
//   textAlign: "center",
// };

export default OrderDetail;
